import React from 'react';
import styled from 'styled-components';

import { ButtonGroup } from '@/ui/ButtonGroup';
import {
  WrapStyled,
  ColumnStyled,
  StyledLabel,
  StyledCaption,
} from '@/features/course/admin/molecules/CourseSettingsModalForm/CourseSettingsModalForm';
import { Button } from '@/ui/Button';
import { EditModularLayoutVariant } from '@/features/course/admin/templates/CourseLayout';

const DuplicateButtonStyled = styled(Button).attrs({ variant: 'secondary', size: 'large' })`
  border: 1px solid ${(p) => p.theme.colors.neutral.outline2};
  width: 100%;
`;

type CourseSettingsModalDuplicateButtonProps = {
  onClick: VoidFunction;
  layoutVariant: EditModularLayoutVariant;
};

export const CourseSettingsModalDuplicateButton = ({ onClick }: CourseSettingsModalDuplicateButtonProps): JSX.Element => {
  return (
    <WrapStyled>
      <ColumnStyled>
        <ButtonGroup gap="small" direction="vertical">
          <StyledLabel>Duplicate</StyledLabel>
          <StyledCaption>Create a copy of your course</StyledCaption>
        </ButtonGroup>
      </ColumnStyled>
      <ColumnStyled>
        <DuplicateButtonStyled type="button" onClick={onClick}>
          Duplicate
        </DuplicateButtonStyled>
      </ColumnStyled>
    </WrapStyled>
  );
};
